'use client';

import HomeTitle from '@/components/home/home-title';
import { getImageByLocale } from '@/utils/config';
import { CategoryCard } from '../cards';
import { useEffect } from 'react';

const HomeCategoriesSlider = ({
  data,
  locale,
  isMobile,
  fromCategories,
  isFromCategoriesPage,
}) => {
  const active = isMobile ? 'mobile-active' : 'active';
  const position = isMobile ? 'mobile-position' : 'position';
  const activeData = data?.value
    ?.filter((item) => (!fromCategories ? item?.[active] : true))
    ?.sort((a, b) => +a[position] - +b[position]);

  useEffect(() => {
    if (activeData && activeData.length > 0) {
      const storedData = localStorage.getItem('featured-categories');
      if (!storedData) {
        localStorage.setItem(
          'featured-categories',
          JSON.stringify({ value: activeData })
        );
      }
    }
  }, [activeData]);

  return (
    <>
      {activeData?.length > 0 && (
        <section className='mt-4 flex flex-col gap-2.5 sm:mt-5.5 md:mt-7 lg:mt-9'>
          {data?.[`title-${locale}`] && (
            <HomeTitle
              title={data?.[`title-${locale}`]}
              link={data?.url}
              linkTitle={locale === 'en' ? 'Show All' : 'عرض الكل'}
            />
          )}
          {/* --- MODIFIED LINE BELOW --- */}
          <div
            className={`grid w-full max-sm:grid-cols-3 ${isFromCategoriesPage ? 'grid-cols-[repeat(auto-fill,minmax(130px,1fr))]' : 'grid-cols-[repeat(auto-fit,minmax(130px,1fr))]'} gap-1 sm:gap-3 md:gap-4 lg:gap-[18px]`}
          >
            {activeData?.map((info, index) => (
              <div
                key={index}
                className='max-md:*:items-center max-md:*:justify-center'
              >
                <CategoryCard
                  clickLocation={
                    fromCategories ? 'categories_index' : 'hp_featured_categories'
                  }
                  target={!fromCategories ? info?.['open-in-new-tab'] ? '_blank' : '_self' : '_self'}
                  img={
                    !fromCategories
                      ? getImageByLocale(info, locale, isMobile)
                      : (process.env.NEXT_PUBLIC_IMG_BASEURL +
                        info?.['category_desktop_image1']?.replace(
                          /^\/pub/,
                          ''
                        ) ?? '')
                  }
                  title={
                    !fromCategories
                      ? `${info?.[`title-${locale}`]} `
                      : info?.name || info?.[`title-${locale}`]
                  }
                  link={`/c/${(info?.currentURL?.startsWith('/') ? info?.currentURL?.replace('/', '') : info?.currentURL) || info?.innova_url || info?.url}`}
                  fromCategoriesSlider
                  imgClassName='max-sm:!w-11/12 max-sm:!mx-auto max-sm:!min-h-[128px]'
                  titleClassName='max-sm:!w-11/12 max-sm:!mx-auto w-full overflow-hidden text-ellipsis'
                />
              </div>
            ))}
          </div>
        </section>
      )}
    </>
  );
};

export default HomeCategoriesSlider;
